import {Button, BUTTON_SIZE, BUTTON_THEMES} from 'components/Button';
import {Typography} from 'components/Typography';
import {IDataAutotestDetailedProps} from 'core/types';
import React, {FC, useMemo} from 'react';

import style from './style.module.scss';

interface IProps extends IDataAutotestDetailedProps {
    title?: string;
    bonuses?: number;
}

export const BonusPopup: FC<IProps> = ({
    dataAutotestTarget,
    dataAutotestTargetTextId,
    dataAutotestTargetBtnId,
    dataAutotestTargetLinkId,
    bonuses,
    title = 'За каждую покупку в SimpleWine начислим бонусы. Ими можно оплатить до 50% стоимости заказа.',
}) => {
    const renderDescription = useMemo(() => {
        if (bonuses && 0 < bonuses) {
            return (
                <>
                    <Typography element={'div'} variant={'label-16-m'}>
                        {bonuses} бонусных баллов
                    </Typography>
                    <Typography element={'div'} variant={'body-16-r'}>
                        доступно для оплаты заказа на сайте и в приложении.
                    </Typography>
                </>
            );
        }

        return (
            <Typography
                data-auototest-target={dataAutotestTarget}
                data-auototest-target-id={`${dataAutotestTargetTextId}-text`}
                element={'div'}
                variant={'p'}
            >
                {title}
            </Typography>
        );
    }, [bonuses, dataAutotestTarget, dataAutotestTargetTextId, title]);

    return (
        <div className={style.bonusPopupContainer}>
            {renderDescription}
            <Button
                className={style.buttonBonus}
                data-auototest-target={dataAutotestTarget}
                data-auototest-target-id={`${dataAutotestTargetBtnId}-btn`}
                href={'/catalog/vino'}
                isStretched={true}
                size={BUTTON_SIZE.small}
                theme={BUTTON_THEMES.primary}
            >
                Посмотреть каталог
            </Button>
            <Button
                className={style.buttonBonus}
                data-auototest-target={dataAutotestTarget}
                data-auototest-target-id={`${dataAutotestTargetLinkId}-link`}
                href={'/loyalty'}
                isStretched={true}
                size={BUTTON_SIZE.small}
                theme={BUTTON_THEMES.ghost}
            >
                Узнать больше о бонусной системе
            </Button>
        </div>
    );
};
